import React, { useState, useEffect } from "react";
import { CommunityMonthSelector } from "../../../components/community/month-selector";
import { MAKEMAKE_LIVE_MONTHS } from "../../data/makemake-live";
import moment from "moment";
import { Events } from "./components/events";
import { useEvents } from "../../hooks/use-events";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";
import { useLanguage } from "../../../hooks/use-language";

/**
 * Sección MakeMake Live dentro de Reading Resources.
 *
 * Resuelve los meses visibles y conecta la selección con el listado de eventos.
 */
export const MakeMakeLive = React.forwardRef((props, ref) => {
	const lang = useLanguage();
	const texts = useTranslationsById({ mainSectionName: "reading_resources", language: lang });
	const [months, setMonths] = useState([]);
	const [defaultMonth, setDefaultMonth] = useState(null);

	const [currentMonth, setCurrentMonth] = useState(defaultMonth);
	const monthsEvents = useEvents({ month: currentMonth });
	const loadingEvents = monthsEvents?.loading;
	const events = monthsEvents.events;
	const allEvents = monthsEvents.allEvents;

	useEffect(() => {
		if (Array.isArray(allEvents)) {
			const liveMonths = [...MAKEMAKE_LIVE_MONTHS].map((month) => {
				return {
					...month,
					name: texts.getText({
						id: month?.name?.translationPath,
						defaultText: month?.name?.default,
					}),
					empty: !allEvents
						.map((e) => moment(e?.fecha).format("YYYY-MM"))
						.includes(moment(month?.date).format("YYYY-MM")),
				};
			});
			setDefaultMonth(
				liveMonths.find(
					(month) =>
						moment().isSame(month?.date, "month") &&
						moment().isSame(month?.date, "year"),
				)?.id || liveMonths[0]?.id,
			);
			setMonths(liveMonths);
		}
	}, [allEvents, texts.fullData, lang]);

	return (
		<div className="section makemake-live w-100 pb-0">
			<div className="container">
				<div ref={ref} style={{ scrollMarginTop: 80 }}>
					<h2
						className="heading-3 onbackground-color title-font text-left"
						style={{ fontWeight: 400 }}
					>
						{texts.getText({
							id: "makemake_en_vivo.titulo",
							defaultText: "MakeMake Live",
						})}
					</h2>
				</div>
				<p
					className="body-base md:body-l onbackground-color my-5 col-12 col-lg-7 px-0"
					style={{ fontWeight: 600 }}
				>
					{texts.getText({
						id: "makemake_en_vivo.descripcion",
						defaultText:
							"Join live author events, performances, workshops, and training sessions throughout the year",
					})}
				</p>
				<CommunityMonthSelector
					months={months}
					defaultMonthId={defaultMonth || months[0]?.id}
					onSelect={(month) => {
						setCurrentMonth(month);
					}}
				/>
			</div>
			<Events loading={loadingEvents} events={events} lang={lang} />
		</div>
	);
});
